<div class="choice-chips" [class.is-segmented]="!multiple()" role="group" [attr.aria-label]="ariaLabel() || null">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="choice-chip"
      [class.is-chosen]="isChosen(option)"
      [attr.aria-pressed]="isChosen(option)"
      [attr.title]="option.hint || null"
      (click)="choose(option)"
    >
      @if (multiple()) {
        <i class="fa choice-chip-tick" [class.fa-check]="isChosen(option)" aria-hidden="true"></i>
      }
      {{ option.label }}
    </button>
  }
  @if (multiple() && options().length > 2) {
    <span class="choice-chips-bulk">
      <button type="button" class="choice-chips-link" (click)="chooseAll()" i18n>All</button>
      <button type="button" class="choice-chips-link" (click)="chooseNone()" i18n>None</button>
    </span>
  }
</div>
